import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ctr-custom-icon',
  imports: [CommonModule, MatIconModule],
  templateUrl: './custom-icon.component.html',
  styleUrl: './custom-icon.component.scss',
})
export class CustomIconComponent implements OnInit, OnChanges {
  @Input() icon: string | undefined;
  @Input() custom = false;
  @Input() color = '#000';
  @Input() size = '1em';
  @Input() outlined = true;
  isWhatsapp = false;

  isSelect = false;

  ngOnInit(): void {
    this.setSpecial();
  }

  ngOnChanges(): void {
    this.setSpecial();
  }

  setSpecial() {
    if (!this.icon) return;
    const regexp = /fa-|fas-/;
    this.custom = !this.custom && regexp.test(this.icon) ? true : this.custom;
  }
}
